const MinBalanceCalculationMethods: any = {
  DAILY_BALANCE: 'Daily Balance',
  AVERAGE_DAILY_BALANCE: 'Average Daily Balance',
};

export default MinBalanceCalculationMethods;
